function checkByobTotalQty() {
  let totalQty = 0;

  $('.byob-product-card.byob-active').each(function () {
    const qty = parseInt($(this).find('.byob-quantity-display').text(), 10);
    totalQty += qty;
  });

  if (totalQty >= 3) {
    $('.byob-add-to-box-btn').prop('disabled', true);
    $('.byob-increase-qty').prop('disabled', true);
  } else {
    $('.byob-add-to-box-btn').prop('disabled', false);
    $('.byob-increase-qty').prop('disabled', false);
  }

  return totalQty <= 3;
}

function checkByobTotalQty() {
  let totalQty = 0;

  $('.byob-product-card.byob-active').each(function () {
    const qty = parseInt($(this).find('.byob-quantity-display').text(), 10);
    totalQty += qty;
  });

  if (totalQty >= 3) {
    $('.byob-add-to-box-btn').prop('disabled', true);
    $('.byob-increase-qty').prop('disabled', true);
  } else {
    $('.byob-add-to-box-btn').prop('disabled', false);
    $('.byob-increase-qty').prop('disabled', false);
  }

  return totalQty <= 3;
}

function updateByobTotalPrice() {
  const $actionBar = $('.byob-action-bar');

  let totalPrice = 0;
  let totalQty = 0;

  $('.byob-product-card.byob-active').each(function () {
    const price = parseFloat($(this).data('price')); // In cents
    const qty = parseInt($(this).find('.byob-quantity-display').text(), 10);
    totalPrice += price * qty;
    totalQty += qty;
  });

  const originalPrice = totalPrice / 100; // Convert cents to dollars
  let finalPrice = originalPrice;
  let discountPercent = 0;

  if (totalQty === 2) {
    discountPercent = 27;
  } else if (totalQty === 3) {
    discountPercent = 36;
  }

  finalPrice = originalPrice * ((100 - discountPercent) / 100);
  const savings = originalPrice - finalPrice;

  $('#byob-original-price').text(originalPrice.toFixed(2));
  $('#byob-discounted-price').text(finalPrice.toFixed(2));
  $('#byob-savings').text(savings.toFixed(2));

  if (totalQty >= 2) {
    $actionBar.addClass('active');
  } else {
    $actionBar.removeClass('active');
  }
}

function collectByobItems() {
  const items = [];

  $('.byob-product-card.byob-active').each(function () {
    const variantId = $(this).data('variant-id');
    const qty = parseInt($(this).find('.byob-quantity-display').text(), 10);
    if (variantId && qty > 0) {
      items.push({ id: variantId, quantity: qty, properties: { '_bundle_item': "true" } });
    }
  });

  return items;
}

$(document).ready(function () {
  $('.byob-add-to-box-btn').on('click', function () {
    const $card = $(this).closest('.byob-product-card');
    $card.addClass('byob-active');
    const $qty = $card.find('.byob-quantity-display');
    let simulatedQty = parseInt($qty.text(), 10);

    let totalQty = 0;
    $('.byob-product-card.byob-active').each(function () {
      totalQty += parseInt($(this).find('.byob-quantity-display').text(), 10);
    });

    if (totalQty > 3) {
      $card.removeClass('byob-active');
      return;
    }

    $(this).hide();
    $card.find('.byob-quantity-selector').removeClass('byob-hidden');
    updateByobTotalPrice();
    checkByobTotalQty();
  });

  $('.byob-increase-qty, .byob-decrease-qty').on('click', function () {
    const $card = $(this).closest('.byob-product-card');
    const $qtyDisplay = $card.find('.byob-quantity-display');
    let qty = parseInt($qtyDisplay.text(), 10);

    if ($(this).hasClass('byob-increase-qty')) {
      qty += 1;
      $qtyDisplay.text(qty);

      if (!checkByobTotalQty()) {
        qty -= 1;
        $qtyDisplay.text(qty);
        return;
      }
    } else {
      qty -= 1;
      if (qty < 1) {
        $qtyDisplay.text('1');
        $card.removeClass('byob-active');
        $card.find('.byob-quantity-selector').addClass('byob-hidden');
        $card.find('.byob-add-to-box-btn').show();
        updateByobTotalPrice();
        checkByobTotalQty();
        return;
      }

      $qtyDisplay.text(qty);
    }

    updateByobTotalPrice();
    checkByobTotalQty();
  });

  $('#byob-add-to-cart').on('click', function () {
    const items = collectByobItems();
    const totalQty = items.reduce((sum, item) => sum + item.quantity, 0);

    if (totalQty < 2 || totalQty > 3) {
      alert('Please select a minimum of 2 and maximum of 3 items in total.');
      return;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({ items }),
      success: function () {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        const cartLink = document.querySelector('.header__cart-link a');
        if (cartLink) {
          cartLink.dispatchEvent(new CustomEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          }));
        }
        // window.location.href = '/cart';
      },
      error: function (err) {
        alert('Error adding items to cart.');
        console.error(err);
      }
    });
  });
});
